import React, { useState } from "react";
import PageShell from "../dashboard/PageShell";
import {
  ForeignStaffBasicInfo,
  ForeignStaffContactInfo,
  ForeignStaffFileUpload,
  ForeignStaffFormActions,
} from "../../components/forms/ForeignStaffForm";

interface AddNewForeignStaffProps {}

const AddNewForeignStaff: React.FC<AddNewForeignStaffProps> = () => {
  const [formData, setFormData] = useState({
    fullName: "",
    dateOfBirth: "",
    gender: "",
    phone: "",
    qualification: "",
    academicRank: "",
    degree: "",
    role: "",
    email: "",
    passportNumber: "",
    passportExpiry: "",
    visaExpiry: "",
    entryDate: "",
    temporaryAddress: "",
    nationality: "",
    country: "",
    organization: "",
    notes: "",
    attachedFiles: [] as File[],
  });

  const handleInputChange = (field: string, value: string | File[]) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleSave = () => {
    console.log("Saving foreign staff data:", formData);
    // TODO: Implement save functionality
  };

  return (
    <PageShell title="Thêm mới Cán bộ nước ngoài">
      <div className="space-y-4">
        {/* Header Section */}
        <div className="flex justify-between items-center">
          <h1 className="text-xl font-semibold text-gray-800">
            Thêm mới Cán bộ nước ngoài
          </h1>
        </div>

        {/* Form Section */}
        <div className="bg-white rounded-lg p-4">
          <div className="space-y-4">
            <ForeignStaffBasicInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <ForeignStaffContactInfo
              formData={formData}
              handleInputChange={handleInputChange}
            />

            <ForeignStaffFileUpload
              formData={formData}
              handleInputChange={handleInputChange}
            />
          </div>
        </div>

        <ForeignStaffFormActions
          onSave={handleSave}
          onCancel={() => window.history.back()}
        />
      </div>
    </PageShell>
  );
};

export default AddNewForeignStaff;
